class ProductInventory extends HTMLElement {
  constructor() {
    super();
    this.shopUrl = this.getAttribute('shop-url');
    this.productId = this.getAttribute('product-id');
    this.productVariantId = this.getAttribute('product-variant-id');
    this.selectedSku = this.getAttribute('selected-sku');
    this.rootURL = 'https://digitalunicorn.aurubis.ch/api/shopify/stocks';
    this.locations = JSON.parse(this.getAttribute('data-locations'), '[]');
    this.skus = JSON.parse(this.getAttribute('data-skus'), '[]');
    this.variantData = this.parseVariantData(this.getAttribute('data-variants'));
    this.inventoryData = null;
    this.variantEventNames = ['variant:change', 'theme:variant:change'];
    this.variantSubscription = null;
    this.handleVariantChange = this.handleVariantChange.bind(this);
    this.handleVariantInputChange = this.handleVariantInputChange.bind(this);
    this.template = {
      oos: `<span style="padding: 4px 8px;color: #D91616;background: #F7D0D0;border-radius: 8px;display: inline-block;font-weight: normal;">
                  Voir disponibilité dans nos autres boutiques
                </span>`,
      in_stock: `<span style="padding: 4px 8px;background: #CCF2D6;border-radius: 8px;display: inline-block;font-weight: normal;color: #00BF30; ">
                  {{quantity}} pièce disponible
                </span>`          
    }
  }
  
  async connectedCallback() {
    this.listenToVariantChanges();
    this.bindVariantInputListener();
    this.triggerLocationSelectorUpdate();
    await this.loadRecentProducts();
  }

  disconnectedCallback() {
    this.removeVariantListeners();
    this.unbindVariantInputListener();
  }

  async getRecentProducts() {
    try {
      const response = await fetch(this.rootURL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer 694271821527ad78b348882dfef43c5b24eb2cb1d284540b28ea220fe3726cd8'
        },
        body: JSON.stringify({
          skus: this.skus,
          locations: this.locations
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data.data;
      
    } catch (error) {
      throw error;
    }
  }

  triggerLocationSelectorUpdate() {
    try {
      // Get the selected location from localStorage
      const selectedLocation = localStorage.getItem('vt_selected_location');
      if (!selectedLocation) {
        return;
      }

      // Find the location selector and its select element
      const locationSelector = document.querySelector('location-selector');
      if (!locationSelector) {
        return;
      }

      const select = locationSelector.querySelector('select#country-list, select.js-country-list');
      if (!select) {
        return;
      }

      // Set the value and trigger change event
      select.value = selectedLocation;
      const changeEvent = new Event('change', { bubbles: true });
      select.dispatchEvent(changeEvent);
    } catch (error) {
      console.error('Error triggering location selector update:', error);
    }
  }

  async loadRecentProducts() {
    try {
    /* sample data
      {
        "105564406107": {
            "BABEBA267619": 0
        },
        "105704784219": {
            "BABEBA267619": 0
        },
        "105704653147": {
            "BABEBA267619": 0
        },
        "105704718683": {
            "BABEBA267619": 0
        },
        "105564307803": {
            "BABEBA267619": 0
        },
        "105704685915": {
            "BABEBA267619": 0
        },
        "105704489307": {
            "BABEBA267619": 0
        },
        "105704620379": {
            "BABEBA267619": 0
        },
        "105088909659": {
            "BABEBA267619": 0
        },
        "105704554843": {
            "BABEBA267619": 0
        }
    }*/
      const data = await this.getRecentProducts();
      this.inventoryData = data;
      this.renderHTML();
    } catch (error) {
      console.error(error);
    }
  }
  renderHTML() {
    if (!this.inventoryData) {
      return;
    }

    // Update data-location-id of the default store table based on selected location
    this.updateDefaultStoreLocationId();

    // Normalize inventoryData keys to handle both string and number formats
    const normalizedInventoryData = {};
    Object.keys(this.inventoryData).forEach(key => {
      normalizedInventoryData[String(key)] = this.inventoryData[key];
    });

    Object.keys(normalizedInventoryData).forEach(key => {
      const item = normalizedInventoryData[key] || {};
      // Try both string and number format for location-id
      const elements = [
        ...document.querySelectorAll(`[data-location-id="${key}"]`),
        ...document.querySelectorAll(`[data-location-id="${Number(key)}"]`)
      ];
      
      // Remove duplicates
      const uniqueElements = [...new Set(elements)];
      const quantity = this.getQuantityForCurrentVariant(item);
      
      if(uniqueElements.length > 0) {
        let html;
        if (quantity > 0) {
          const pieceText = quantity > 1 ? 'pièce disponibles' : 'pièce disponible';
          html = this.template.in_stock.replace('{{quantity}}', quantity).replace('pièce disponible', pieceText);
        } else {
          html = this.template.oos;
        }
        
        uniqueElements.forEach((element) => {
          const inventoryElement = element.querySelector('[data-inventory]');
          if (inventoryElement) {
            inventoryElement.innerHTML = html;
          }
        });
      }
      // Silently skip locations that don't exist in DOM (they might not be displayed)
    });
  }

  updateDefaultStoreLocationId() {
    try {
      // Get the location selector to find the selected location name
      const locationSelector = document.querySelector('location-selector');
      if (!locationSelector) {
        return;
      }

      const select = locationSelector.querySelector('select#country-list, select.js-country-list');
      if (!select) {
        return;
      }

      // Get the location name from the selected option (text), not the value (URL)
      const selectedLocationName = select.querySelector('option:checked')?.text;
      if (!selectedLocationName) {
        return;
      }

      // Find the element with data-location matching the selected location name
      const locationElement = document.querySelector(`[data-location="${selectedLocationName}"]`);
      if (!locationElement) {
        return;
      }

      const selectedLocationId = locationElement.getAttribute('data-location-id');
      if (!selectedLocationId) {
        return;
      }

      // Find the default store table (the one containing .active-table)
      const activeTable = document.querySelector('.active-table');
      if (!activeTable) {
        return;
      }

      const defaultStoreTable = activeTable.closest('table[data-location-id]');
      if (defaultStoreTable && defaultStoreTable.getAttribute('data-location-id') !== selectedLocationId) {
        // Update the data-location-id to match the selected location
        defaultStoreTable.setAttribute('data-location-id', selectedLocationId);
      }
    } catch (error) {
      console.error('Error updating default store location-id:', error);
    }
  }

  getQuantityForCurrentVariant(item) {
    if (this.selectedSku && Object.prototype.hasOwnProperty.call(item, this.selectedSku)) {
      return item[this.selectedSku];
    }

    return Object.values(item).reduce((acc, curr) => acc + curr, 0);
  }

  listenToVariantChanges() {
    const hasPubSub =
      typeof subscribe === 'function' &&
      typeof PUB_SUB_EVENTS !== 'undefined' &&
      PUB_SUB_EVENTS.variantChange;

    if (hasPubSub) {
      this.variantSubscription = subscribe(PUB_SUB_EVENTS.variantChange, this.handleVariantChange);
      return;
    }

    this.variantEventNames.forEach(eventName => {
      document.addEventListener(eventName, this.handleVariantChange);
    });
  }

  removeVariantListeners() {
    if (this.variantSubscription) {
      this.variantSubscription();
      this.variantSubscription = null;
    }

    this.variantEventNames.forEach(eventName => {
      document.removeEventListener(eventName, this.handleVariantChange);
    });
  }

  handleVariantChange(event) {
    const variant =
      event?.data?.variant ||
      event?.detail?.variant ||
      event?.variant ||
      undefined;

    if (!variant) {
      return;
    }

    if (`${variant.product_id}` !== this.productId) {
      return;
    }

    if (variant.sku === this.selectedSku) {
      return;
    }

    this.selectedSku = variant.sku;
    this.renderHTML();
  }

  bindVariantInputListener() {
    const productInfo = this.closest('product-info');
    if (!productInfo) {
      return;
    }

    this.variantInput = productInfo.querySelector('input[name="id"]');
    if (!this.variantInput) {
      return;
    }

    this.variantInput.addEventListener('change', this.handleVariantInputChange);
  }

  unbindVariantInputListener() {
    if (this.variantInput) {
      this.variantInput.removeEventListener('change', this.handleVariantInputChange);
      this.variantInput = null;
    }
  }

  handleVariantInputChange(event) {
    const variantId = event?.target?.value;
    if (!variantId) {
      return;
    }

    const sku = this.variantData[variantId];
    if (!sku || sku === this.selectedSku) {
      return;
    }

    this.selectedSku = sku;
    this.renderHTML();
  }

  parseVariantData(rawVariants) {
    if (!rawVariants) {
      return {};
    }

    let parsed;
    try {
      parsed = JSON.parse(rawVariants);
    } catch (error) {
      console.error('Failed to parse variant data for product-inventory', error);
      return {};
    }

    if (!Array.isArray(parsed)) {
      return {};
    }

    return parsed.reduce((accumulator, variant) => {
      if (variant?.id && typeof variant?.sku === 'string') {
        accumulator[variant.id] = variant.sku;
      }
      return accumulator;
    }, {});
  }
}

customElements.define("product-inventory", ProductInventory);